// extracted by mini-css-extract-plugin
export default {"main":"style_main__3CWkl","content":"style_content__lsqCe","constructor":"style_constructor__NOIQb"};